import { useEffect } from "react";

export default function useExternalScript(url?: string): void {

    useEffect(() => {
        if (!url) {
            return;
        }
        const id = getSrcId(url);
        const existing = document.getElementById(id);

        if (!existing) {
            const script = document.createElement("script");
            script.id = id;
            script.src = url;
            script.crossOrigin = 'anonymous';
            document.head.appendChild(script);
        }
    }, [url]);
}

function getSafeCh(ch: string): string {
    if (ch >= "0" && ch <= "9") {
        return ch;
    }
    if (ch >= "a" && ch <= "z") {
        return ch;
    }
    if (ch >= "A" && ch <= "Z") {
        return ch;
    }
    return `_${ch.charCodeAt(0)}_`;
}

function getSrcId(url: string) {
    let res = "es-";
    for (let i = 0; i < url.length; i++) {
        res += getSafeCh(url.charAt(i));
    }
    return res;
}